import React from "react";
import GetInvitations from "./GetInvitations";

const ProfileInvitations: React.FC = () => {
  return (
    <div className="center">
      <GetInvitations />
    </div>
  );
};

export default ProfileInvitations;
